export default "__VITE_ASSET__DUTog8fC__"